import { useMemo } from 'react';
import {
  useS3Data,
} from '../../../../hooks';
import { toSlugCase } from '../../../../modules/stringUtils';
import analytics from '../../../../modules/analytics';

import {
  IQuerySuggestionList, QueryResultType,
} from './types';

import {
  POPULAR_SUGGESTIONS_EVENT,
} from './constants';

const usePopularMatchSuggestions = (
  initialQuery: string | null,
): {
  loadingPopularMatches: boolean;
  popularMatchSuggestions: Array<IQuerySuggestionList>
} => {
  /*
  Popular suggestions based off of the user's last initial query
  */
  const [loadingPopularMatches, popularMatchesData] = useS3Data<string[] | null>(
    'ATL-3715',
    initialQuery ? toSlugCase(initialQuery) : '',
    [initialQuery],
  );

  const popularMatchSuggestions = useMemo<IQuerySuggestionList[]>(() => {
    if (loadingPopularMatches || !popularMatchesData) {
      return [];
    }

    analytics.track(POPULAR_SUGGESTIONS_EVENT, {
      query: initialQuery,
    });

    return [{
      title: `People who viewed ${initialQuery} also searched`,
      testId: 'popular-service-suggestion-section',
      data: popularMatchesData.map((query: string, id: number) => ({
        id: query,
        text: query,
        testId: `popular-service-suggestion-${id}`,
        matchedSubstrings: [0, query.length - 1],
        section: QueryResultType.ALSO_SEARCHED,
        data: {
          isPopularSuggestion: true,
          search_query: { query },
          display_text: query,
          matchedSubstrings: [],
        },
      })),
    }];
  }, [popularMatchesData, initialQuery, loadingPopularMatches]);

  return {
    loadingPopularMatches: loadingPopularMatches || popularMatchSuggestions === undefined,
    popularMatchSuggestions,
  };
};

export default usePopularMatchSuggestions;
